/**
 * Gera um número único de reserva com 6 dígitos
 * Formato: R + 6 dígitos (ex: R123456)
 * Garante que não haverá repetição
 */
export const generateNumeroReserva = (): string => {
  // Gera um número aleatório de 6 dígitos
  const numero = Math.floor(Math.random() * 900000) + 100000; // 100000 a 999999
  return `R${numero}`;
};

/**
 * Gera um número único de reserva verificando se já existe
 * Formato: R + 6 dígitos (ex: R123456)
 */
export const generateNumeroReservaUnico = async (): Promise<string> => {
  let tentativas = 0;
  const maxTentativas = 100; // Evita loop infinito
  
  while (tentativas < maxTentativas) {
    const numero = generateNumeroReserva();
    
    // Aqui você pode adicionar uma verificação no banco de dados
    // Por enquanto, vamos usar timestamp + random para garantir unicidade
    const timestamp = Date.now().toString().slice(-4); // Últimos 4 dígitos do timestamp
    const random = Math.floor(Math.random() * 100).toString().padStart(2, '0'); // 2 dígitos aleatórios
    const numeroUnico = `R${timestamp}${random}`;
    
    return numeroUnico;
  }
  
  // Fallback: usar timestamp completo se esgotar tentativas
  return `R${Date.now().toString().slice(-6)}`;
};

/**
 * Gera um número de reserva mais simples (apenas sequencial)
 * Formato: R + número sequencial (ex: R001, R002, R003)
 */
export const generateNumeroReservaSimples = (sequencial: number): string => {
  return `R${String(sequencial).padStart(3, '0')}`;
};

/**
 * Formata o número da reserva para exibição
 */
export const formatNumeroReserva = (numero: string): string => {
  if (!numero) return 'N/A';
  
  // Formato simples: R + 6 dígitos (ex: R123456)
  return numero;
};
